import Vue from 'vue'
import VueGoodTablePlugin from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import _ from 'lodash'
import map from '../lost-pet-map/index'

Vue.use(VueGoodTablePlugin)

export default Vue.component('lostpet-listing', {
  props: [],
  data() {
    return {
      loading: false,
      errorMessage: '',
      rows: [],
      markers: [],
      tab: 'list',
      mapRegion: '',
      mapLoaded: false,
      mapInit: false,
    }
  },
  async mounted() {
    const currentSearchUrl = window.location.search
    const searchParams = new URLSearchParams(currentSearchUrl)

    const mode = searchParams.get('mode')
    this.tab = mode ? mode : 'list'

    // Initialise and display map, and set any data we have already
    await map.init()
    this.mapInit = true
    map.update({ markers: this.markers, region: this.mapRegion })

    // If data is already loaded, show the map now
    if (!this.loading) {
      this.mapLoaded = true
    }
  },
  methods: {
    onTabChange(value) {
      const currentSearchUrl = window.location.search
      const url = new URL(window.location.href)

      const searchParams = new URLSearchParams(currentSearchUrl)

      searchParams.set('mode', value)
      url.search = searchParams.toString()

      window.history.replaceState(null, null, url.href)

      this.tab = value
    },
    onRefreshResults(rows, markers) {
      this.rows = rows
      this.markers = markers
      map.update({ markers })
    },
    onLoadingChange(state) {
      const mapInitialisedButWaitingOnData = !this.mapLoaded && this.mapInit
      const dataLoaded = state === false
      if (mapInitialisedButWaitingOnData && dataLoaded) {
        this.mapLoaded = true
      }
      this.loading = state
    },
    onRegionChange(region) {
      this.mapRegion = region
      map.update({ region })
    },
  },
})
